/**
 * Stub for @react-native-firebase/firestore/lib/modular - web build only.
 */
const noop = () => {};
const noopAsync = () => Promise.resolve();

module.exports = {
    getFirestore: noop,
    collection: noop,
    doc: noop,
    query: noop,
    where: noop,
    orderBy: noop,
    limit: noop,
    getDocs: noopAsync,
    getDoc: noopAsync,
    onSnapshot: noop,
    setDoc: noopAsync,
    initializeFirestore: noopAsync,
    Timestamp: { now: noop },
};
